export default function Footer() {
    return (
      <footer className="footer">
        <div className="footer-inner">
          <p>© {new Date().getFullYear()} The Red Box Tees · Built with ♥ in Sydney, Australia</p>
          <p className="fineprint">This site showcases products sold and fulfilled by Redbubble.</p>
        </div>
      </footer>
    );
  }
  